<template>
  <div class="main">
    <div class="body-content">
      <div class="page-header">
        <h1>Upload Ship Movement PDF</h1>
      </div>
      <div class="form-group">
        <div class="form-item">
          <label for="shipmovement-file">PDF File:</label>
          <input
            id="shipmovement-file"
            type="file"
            class="custom-file-input"
            accept=".pdf,application/pdf"
            @change="handleFileUpload"
          />
        </div>

        <div class="form-item">
          <button
            type="button"
            class="excel-button"
            @click="uploadFiles"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? 'Uploading...' : 'Upload' }}
          </button>
        </div>

        <div v-if="message" class="message" :class="messageType">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      selectedFile: null,
      message: '',
      messageType: '',
      isSubmitting: false,
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];

      if (!file) {
        this.selectedFile = null;
        this.message = '';
        this.messageType = '';
        return;
      }

      const allowedTypes = ['application/pdf'];
      const allowedExt = ['.pdf'];
      const name = file.name.toLowerCase();
      const isTypeAllowed = allowedTypes.includes(file.type);
      const isExtAllowed = allowedExt.some((ext) => name.endsWith(ext));

      if (!isTypeAllowed && !isExtAllowed) {
        this.selectedFile = null;
        event.target.value = '';
        useToast().error('Only PDF files are allowed.');
        this.message = 'Only PDF files are allowed.';
        this.messageType = 'error';
        return;
      }

      this.selectedFile = file;
      this.message = `Selected file: ${file.name}`;
      this.messageType = 'info';
    },

    async uploadFiles() {
      if (this.isSubmitting) return;

      if (!this.selectedFile) {
        useToast().error('Please select a PDF file first.');
        this.message = 'Please select a PDF file first.';
        this.messageType = 'error';
        return;
      }

      this.isSubmitting = true;
      this.message = 'Uploading PDF...';
      this.messageType = 'info';

      try {
        const token = localStorage.getItem('access_token');
        const formData = new FormData();
        formData.append('file', this.selectedFile);

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          timeout: 15 * 60 * 1000,
        };

        const response = await axios.post('/upload_shipmovement_pdf', formData, config);

        if (response.data?.[0] === 0) {
          this.message = response.data[1] || 'Upload failed.';
          this.messageType = 'error';
          useToast().error(this.message);
        } else {
          this.message = 'PDF uploaded successfully.';
          this.messageType = 'success';
          useToast().success(this.message);
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'An error occurred during upload.';
        this.message = errorMessage;
        this.messageType = 'error';
        useToast().error(errorMessage);
        console.error(error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.main {
  padding: 20px;
}

.body-content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  max-width: 360px;
}

.custom-file-input {
  border: 1px solid #d0d7de;
  border-radius: 6px;
  padding: 8px;
  background: #fafbfc;
}

.excel-button {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  width: fit-content;
}

.excel-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.message {
  margin-top: 6px;
  font-size: 14px;
}

.message.success {
  color: #28a745;
}

.message.error {
  color: #dc3545;
}

.message.info {
  color: #0066cc;
}
</style>
